<template>
  <div class="first-screen">
    <div class="g-container container">
      <h1 class="title">
        <span>{{ $t('home.slogan1') }}</span>
        <span>{{ $t('home.slogan2') }}</span>
      </h1>
      <div class="tip">{{ $t('home.sloganTip')}}</div>
      <ButtonCreate class="btn--create" />
      <BgAnimation />
    </div>
  </div>
</template>

<script>
import ButtonCreate from '@/components/ButtonCreate.vue';
import BgAnimation from '@/components/BgAnimation.vue';

export default {
  name: 'FirstScreen',
  components: { BgAnimation, ButtonCreate },
};
</script>

<style lang="scss" scoped>
  .first-screen {
    position: relative;
    overflow: hidden;
    height: 100vh;
    text-align: center;
    background-image: url("../../assets/bg-rail.svg");
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: bottom;
  }

  .container {
    width: 100%;
  }

  .title {
    margin: 25vh auto 0;
    padding: 0 30px;
    max-width: 798px;
    font-size: 50px;
    font-weight: 500;
    line-height: 65px;
    font-family: NoumenaFont-Bold, PingFang SC, Microsoft YaHei, SimHei, sans-serif;
    color: var(--color-base);
    background-image: url("../../assets/cloud1.png"), url("../../assets/cloud2.png");
    background-size: 49px, 52px;
    background-position: 0 97px, calc(100% - 10px) 144px;
    background-repeat: no-repeat;

    span {
      display: block;
    }
  }

  .tip {
    margin-top: 20px;
    display: inline-block;
    max-width: 640px;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-content);
  }

  .btn--create {
    display: none;
    @media (max-width: 960px) {
      display: block;
      margin: 60px auto 0;
    }
  }
</style>
